module.exports = __webpack_public_path__ + "static/404-1641cf888db4c83c0bd79c42a731ba1b.png";